import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { mainRoutes } from "./routers/Routers";
import { RoutesWrapper } from "./utils/RoutesWrapper";
import AppLayout from "./layout/appLayout";
import useStore from "./features/store";
import ComingSoon from "./pages/comingSoon";
import "./App.css";

interface Route {
  pathName: string;
  element: JSX.Element;
}

function App() {
  const isSiteDown = process.env.REACT_APP_COMING_SOON;
  const hasToken = localStorage.getItem("refresh_token");
  //@ts-ignore
  const { profile, fetchProfile, isLoadingProfile } = useStore();

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {})
        .catch((err) => {});
    }
  }, []);

  useEffect(() => {
    if (hasToken && !profile && !isLoadingProfile) fetchProfile();
  }, [hasToken, profile]);

  if (isSiteDown === "true") {
    return <ComingSoon />;
  } else {
    return (
      <BrowserRouter>
        <RoutesWrapper>
          <AppLayout>
            <Routes>
              {(mainRoutes as Route[]).map((route, index) => (
                <Route
                  path={route.pathName}
                  element={route.element}
                  key={index}
                />
              ))}
            </Routes>
          </AppLayout>
          <Toaster />
        </RoutesWrapper>
      </BrowserRouter>
    );
  }
}

export default App;
